import { render, staticRenderFns } from "./Notifications.vue?vue&type=template&id=5f21768b&scoped=true"
import script from "./Notifications.vue?vue&type=script&lang=js"
export * from "./Notifications.vue?vue&type=script&lang=js"
import style0 from "./Notifications.vue?vue&type=style&index=0&id=5f21768b&lang=less&scoped=true"
import style1 from "./Notifications.vue?vue&type=style&index=1&id=5f21768b&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f21768b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/linkdeli/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f21768b')) {
      api.createRecord('5f21768b', component.options)
    } else {
      api.reload('5f21768b', component.options)
    }
    module.hot.accept("./Notifications.vue?vue&type=template&id=5f21768b&scoped=true", function () {
      api.rerender('5f21768b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/lib/components/Notifications.vue"
export default component.exports